import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { cvStyles } from '../cvStyles';
import { cvConfig } from '../cvConfig';

/**
 * Componente de Skills del CV
 * Muestra las habilidades técnicas en formato compacto de tags, agrupadas por categoría
 */
export const CVSkills = ({ skills }) => {
  if (!skills || skills.length === 0) return null;

  // Agrupar skills por categoría
  const groupedSkills = skills.reduce((acc, skill) => {
    const category = skill.category || 'Otras';
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(skill);
    return acc;
  }, {});

  // Orden lógico de categorías
  const categoryOrder = [
    'Frontend',
    'Frameworks Frontend',
    'Backend',
    'Frameworks Backend',
    'Database',
    'APIs',
    'E-commerce',
    'Mobile',
    'DevOps',
    'IoT',
    'Testing',
    'Herramientas',
    'Otras'
  ];
  
  // Ordenar categorías según el orden definido
  const sortedCategories = Object.keys(groupedSkills).sort((a, b) => {
    const indexA = categoryOrder.indexOf(a);
    const indexB = categoryOrder.indexOf(b);
    
    // Si ambas están en el orden, usar ese orden
    if (indexA !== -1 && indexB !== -1) return indexA - indexB;
    // Si solo una está en el orden, esa va primero
    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;
    // Si ninguna está en el orden, orden alfabético
    return a.localeCompare(b);
  });

  return (
    <View style={cvStyles.section} wrap={false}>
      <Text style={cvStyles.sectionTitle}>Habilidades Técnicas</Text>
      
      <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 8 }}>
        {sortedCategories.map((category, categoryIndex) => (
          <View 
            key={categoryIndex} 
            style={cvStyles.skillCategory}
          >
            {/* Título de la categoría */}
            <Text style={cvStyles.skillCategoryTitle}>
              {category}
            </Text>
            
            {/* Skills en formato de tags separados por puntos */}
            <Text style={{ 
              fontSize: cvConfig.fonts.size.body, 
              color: cvConfig.colors.text,
              lineHeight: cvConfig.spacing.lineHeight,
            }}>
              {groupedSkills[category].map((skill, index) => (
                <Text key={index}>
                  {skill.name}
                  {index < groupedSkills[category].length - 1 && (
                    <Text style={{ color: cvConfig.colors.secondary }}> · </Text>
                  )}
                </Text>
              ))}
            </Text>
          </View>
        ))}
      </View>
    </View>
  );
};
